import { Divider, Input as InputField, message } from "antd";
import React, { createRef, useEffect, useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { emailVerification, resendOtp } from "../../../api/auth";
import Background from "../../../assets/bg.svg";
import Error from "../../../assets/error.svg";
import Mobile from "../../../assets/mobile.svg";
import Check from "../../../assets/tick.svg";
import LoginLayout from "../../../components/LoginLayout";
import Button from "../../../components/button";
import MemberModal from "../../../components/memberModal";
import Logo from "../../../assets/logo.svg";
import { handleAuthRedirect } from "../../../constants/utils";

const UserOtp = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isErrorModal, setIsErrorModal] = useState(false);
  const [inputValues, setInputValues] = useState(Array(5).fill(""));
  const [loader, setLoader] = useState(false);

  const navigate = useNavigate();
  const otpToken = localStorage.getItem("otpToken");

  const Back = () => {
    navigate(-1);
  };

  const handleSubmit = async () => {
    setLoader(true);
    const input = inputValues.join("");
    const payload = {
      otp_token: otpToken,
      otp: input,
    };
    try {
      const res = await emailVerification(payload);
      if (res) {
        localStorage.setItem("accessToken", res?.access_token);
        localStorage.setItem("refreshToken", res?.refresh_token);
        localStorage.setItem("id", res?.user?.companyId);
        localStorage.setItem("profile", res?.user?.profileImage);
        navigate("/main/user/dashboard");
      } else {
        showErrorModal();
      }
    } catch (error) {
    } finally {
      setLoader(false);
    }
  };

  const inputRefs = Array(5)
    .fill(null)
    .map(() => createRef());

  const handleInput = (index, event) => {
    const input = event.target;
    const inputValue = input.value;

    if (inputValue.length === 1 && index < inputRefs.length - 1) {
      inputRefs[index + 1].current.focus();
    }

    const newInputValues = [...inputValues];
    newInputValues[index] = inputValue;
    setInputValues(newInputValues);
    inputValues[index] = inputValue;

    const isAllFilled = newInputValues.every((value) => value.length === 1);

    const code = newInputValues.join("");
    const isValidCode = /^[0-9]{5}$/.test(code);

    if (isAllFilled && isValidCode) {
      handleSubmit();
    }
  };
  const handleKeyDown = (index, event) => {
    const keyCode = event.keyCode || event.which;
    if (keyCode === 9 && index < 4) {
      return;
    }
    if (
      (keyCode < 48 || (keyCode > 57 && keyCode < 96) || keyCode > 105) &&
      keyCode !== 8
    ) {
      event.preventDefault();
    } else if (
      keyCode === 8 &&
      index > 0 &&
      !inputRefs[index].current.input.value
    ) {
      inputRefs[index - 1].current.focus();
    }
  };
  const handleResendCode = async () => {
    const payload = {
      otp_token: otpToken,
    };
    try {
      const res = await resendOtp(payload);
      if (res) {
        localStorage.setItem("otpToken", res?.otp_token);
        message.success("new OTP has been sent to your phone number and email");
      }
    } catch (error) {}
  };

  const showModal = () => {
    setIsModalOpen(true);
  };
  const showErrorModal = () => {
    setIsErrorModal(true);
  };

  const YesClickHandler = () => {
    navigate("/main/user/dashboard");
    setIsModalOpen(false);
  };
  const NoClickHandler = () => {
    setIsErrorModal(false);
  };
  const hideModal = () => {
    setIsModalOpen(false);
    setIsErrorModal(false);
  };
  useEffect(() => {
    const AdminLogin = localStorage.getItem("Login");
    const Token = localStorage.getItem("accessToken");
    if (AdminLogin && Token) {
      handleAuthRedirect(AdminLogin, navigate);
    }
  }, [navigate]);

  return (
    <div>
      <LoginLayout image={Mobile} bg={Background}>
        <div className="relative">
          <div className="absolute w-5 h-5 bg-blue-500 rounded-full left-10 top-7" />
          <div className="absolute top-0 right-0 w-24 h-24 bg-blue-500 rounded-bl-full" />
        </div>

        <div className="min-h-screen flex items-center justify-center">
          <div className="mx-4 sm:mx-6 lg:mx-20 xl:mx-40 w-full max-w-md">
            <div className="flex justify-center">
              <Link to="https://insurancehive.com/">
                <img src={Logo} alt="logo" className="cursor-pointer" />
              </Link>
            </div>
            <div className="space-y-5">
              <p className="text-2xl sm:text-3xl lg:text-4xl text-center font-bold mt-5">
                Verification OTP
              </p>
              <p className="font-bold">
                Enter the code sent to your Phone Number
              </p>
              <div className="grid grid-cols-5 gap-2">
                {inputRefs.map((ref, index) => (
                  <InputField
                    type="text"
                    ref={ref}
                    key={index}
                    className="w-14 h-16 bg-[#F2F2F2] text-center text-lg"
                    autoFocus={index === 0}
                    maxLength={1}
                    onKeyDown={(event) => handleKeyDown(index, event)}
                    onInput={(event) => handleInput(index, event)}
                  />
                ))}
              </div>
              <div>
                <Button
                  title={"Verify"}
                  type={"primary"}
                  onClick={handleSubmit}
                  loading={loader}
                />
                <p className="mt-4 text-center">
                  Haven't Received the verification code?
                  <u
                    className="no-underline text-blue-500 hover:cursor-pointer ml-2 font-bold"
                    onClick={handleResendCode}
                  >
                    Resend
                  </u>
                </p>
                <div className="px-6">
                  <Divider className="bg-[#C7D1D9] border" />
                </div>
                <Button title={"Back"} type={"secondary"} onClick={Back} />
              </div>
            </div>
          </div>
        </div>

        <div className="relative">
          <div className="absolute bottom-7 w-5 h-5 bg-blue-500 rounded-full left-10" />
          <div className="absolute right-0 bottom-0 w-24 h-24 bg-blue-500 rounded-tl-full" />
        </div>
      </LoginLayout>
      {isModalOpen && (
        <MemberModal
          image={Check}
          title="Verification Code Verfied"
          text="Verified! your verification code is verified."
          onCancel={hideModal}
          onOk={YesClickHandler}
        />
      )}
      {isErrorModal && (
        <MemberModal
          image={Error}
          title="Verification Code Error"
          text="Sorry! Your Verification Code is Wrong
          Please Try Again"
          onCancel={hideModal}
          onOk={NoClickHandler}
        />
      )}
    </div>
  );
};
export default UserOtp;
